import OrderTypeText from './OrderTypeText';
import ExpirationText from './ExpirationText';
import ServiceFeeText from './ServiceFeeText';
import OrderInformationText from './OrderInformationText';


const DISCLAIMERS = {
  orderType: {
    header: 'Order Types',
    text: OrderTypeText,
  },
  expiration: {
    header: 'Day & Good \'Till Cancelled (GTC) Orders',
    text: ExpirationText,
  },
  serviceFee: {
    header: 'Commission/Service Fee',
    text: ServiceFeeText,
  },
  orderInformation: {
    header: 'Order Information',
    text: OrderInformationText,
  },
};

const getDisclaimer = viewName => (
  DISCLAIMERS[viewName]
);

export default getDisclaimer;



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/DisclaimerViews/getDisclaimer.js